"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateConditions = evaluateConditions;
exports.evaluateQuery = evaluateQuery;
const evaluateConditions_1 = require("../condition-engine/evaluateConditions");
const queries_1 = require("../condition-engine/queries");
function evaluateConditions(conditions, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    return (0, evaluateConditions_1.evaluateConditions)(conditions, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride).isValid;
}
function evaluateQuery(query, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    return (0, queries_1.evaluateQuery)(query, answersResolver, repeatedInstanceIdentifiers, timezone, {}, currentDateOverride);
}
